<template>
  <div ref="virtualScrollRef" class="virtual-scroll">
    <div
      class="virtual-scroll-wrap"
      :style="{ height: `${totalContentHeight}px` }"
    >
      <b-list-group
        class="virtual-scroll-content"
        :style="{ transform: `translateY(${transformOffsetY}px)` }"
        flush
      >
        <b-list-group-item
          v-for="(item, index) in visibleItems"
          :key="`virtual-scroll-item-${index}`"
          class="p-0"
          role="button"
          :style="{ minHeight: `${$props.itemHeight}px` }"
          @click.stop="() => $emit('click:item', item)"
        >
          <slot name="item" v-bind="item" />
        </b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  computed,
  ref,
  watch,
  onMounted
} from '@vue/composition-api'

export default defineComponent({
  name: 'VirtualScroll',
  props: {
    items: {
      type: Array,
      required: true
    },
    itemHeight: {
      type: Number,
      default: 32
    },
    nodePadding: {
      type: Number,
      default: 0
    }
  },
  emits: ['click:item'],
  setup(props) {
    const virtualScrollRef = ref(null)

    const visibleItems = ref([])

    const scrollTop = ref(0)

    const totalContentHeight = computed(
      () => props.items.length * props.itemHeight
    )

    const visibleNodesCount = computed(() => {
      const visibleNodesCount =
        Math.floor(200 / props.itemHeight) + 2 * props.nodePadding

      return visibleNodesCount
    })

    const startNode = computed(() => {
      const startNode =
        Math.floor(scrollTop.value / props.itemHeight) - props.nodePadding

      return Math.max(0, startNode)
    })

    const transformOffsetY = computed(() => startNode.value * props.itemHeight)

    watch(
      [() => props.items, startNode],
      ([newItems, newStartNode]) => {
        visibleItems.value = new Array(visibleNodesCount.value)
          .fill(null)
          .map((_, index) => {
            return newItems[index + newStartNode]
          })
      },
      { immediate: true }
    )

    onMounted(() => {
      virtualScrollRef.value.addEventListener('scroll', (evt) => {
        scrollTop.value = evt.target.scrollTop
      })
    })

    return {
      virtualScrollRef,

      visibleItems,

      totalContentHeight,
      transformOffsetY
    }
  }
})
</script>

<style scoped>
.virtual-scroll {
  height: 200px;
  overflow: auto;
}

.virtual-scroll-wrap {
  overflow: hidden;
}
</style>
